module.exports = __webpack_public_path__ + "images/b6a5236e034c7665c58a35230a1c88f5-companylogo.png";